import React, { useState } from "react";
import styles from "./index.module.css";

const InputNumber = ({
  id,
  pounds,
  label,
  key,
  required = false,
  ...inputArgs
}) => {
  const [value, setValue] = useState("");

  const validLabels = ["Price", "Booking Fee", "Customer Pays", "You Receive","Custom Price"];

  const blockInvalidChar = (e) => {
    if (["e", "E", "+", "-"].includes(e.key)) {
      e.preventDefault();
    }
    if (e?.target?.value?.startsWith("0")) {
      e.target.value = e?.target?.value?.slice(1) || "";
    }
  };

  const handleInputChange = (e) => {
    const newValue = e.target.value;
    setValue(newValue); // Update local state

    if (newValue.length > 5 && validLabels.includes(label)) {
      e.preventDefault();
      return;
    }
    // if (label === "No For Guest") {
    //   const numericValue = parseInt(value, 10);
    //   if (numericValue < 1 || numericValue > 5) {
    //     e.preventDefault();
    //     return;
    //   }
    // }

    if (label === "No For Guest") {
      if (value.length > 5) {
        e.preventDefault();
        return;
      }
    }
    if (label === "Age Restriction") {
      if (value.length > 3) {
        e.preventDefault();
        return;
      }
    }

    if (label === "Max Tickets Per Order") {
      if (value.length > 5) {
        e.preventDefault();
        return;
      }
    }

    if (label === "Min Tickets Per Order") {
      if (value.length > 5) {
        e.preventDefault();
        return;
      }
    }
    if (label === "Quantity Available") {
      if (value.length > 5) {
        e.preventDefault();
        return;
      }
    }

    if (label === "Custom Price") {
      if (value.length > 5) {
        e.preventDefault();
        return;
      }
    }

    if (label === "Price") {
      if (value.length > 5) {
        e.preventDefault();
        return;
      }
    }
    if (label ==="Discount(%)"){
      if (value.length > 4) {
        e.preventDefault();
        return;
      }
    }
    if (label === "Commission(%)") {
      if (value.length > 4) {
        e.preventDefault();
        return;
      }
    }
 
    inputArgs.onChange && inputArgs.onChange(e);
  };

  return (
    <div
      className={`${styles.formGroup} ${inputArgs?.formGroupClassOverride}`}
      style={inputArgs.formGroupStyleOverride}
      key={key}
    >
      {label && (
        <label style={inputArgs.labelStyleOverride} htmlFor={id}>
          {label} {required && <span className="required">*</span>}
        </label>
      )}
      <div className={styles.InputpriceGroup}>
        <input
          maxLength={
            label === "Age Restriction"
              ? 3
              : label === "Max Tickets Per Order" ||
                label === "Min Tickets Per Order" ||
                label === "Quantity Available" ||
                label === "No Of Guests" ||
                label === "Custom Price" ||
                label === "Price"
              ? 5
              : label === "Commission(%)"||
                label === "Discount(%)"
              ? 4
              : 35
          }
          required={required}
          // className={label === "Price" &&  value || label === "Custom Price" && value ? styles.priceInput:  styles.input}
          className={(validLabels.includes(label) || (label === "Custom Price" && value)) ? styles.priceInput : styles.input}
          value={value}
          style={inputArgs.inputStyleOverride}
          {...inputArgs}
          // pattern="[a-z]"
          // pattern="[0-9]"
          // onChange={handleChange}
          // onKeyDown={blockInvalidChar}
          onKeyDown={blockInvalidChar} // Block invalid characters on keydown
          onChange={handleInputChange}
          // min={label === "No For Guest" ? 1 : undefined}
          // max={label === "No For Guest" ? 5 : undefined}
          // onChange={(e) => {
          //     console.log("Input value:", e.target.value);
          //     inputArgs.onChange(e); // Pass the value to the parent onChange
          // }}
        />
     {pounds &&  (validLabels.includes(label) || label === "Custom Price") && (
  <span className={styles.pound}>£</span>
)}

      </div>
    </div>
  );
};

export default React.memo(InputNumber);
